import { render } from "./Call.vue?vue&type=template&id=0e643759"
import script from "./Call.vue?vue&type=script&lang=ts"
export * from "./Call.vue?vue&type=script&lang=ts"

import "./Call.vue?vue&type=style&index=0&id=0e643759&lang=scss"
script.render = render

export default script